import { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import PurchaseForm from "./purchaseForm";
import UserInfo from "src/components/common/userInfo";
import MyContextMenu from "./myContextMenu";
import TransferSelect from "./transferSelect";
import { useMyStore } from "src/components/main/mainStore";
import {
    mimeTypeMap, 
    myAxios, MyFormData, isDevMode, 
    scroll
} from "src/components/common/functions";

const title = "Purchases";
//--------------------------------------------------------------------------------------------
export default function Detail({
    vendorList, 
    usersList, 
    usersListMap, 
    projectsList, 
    projectsListMap, 
    paymentMethodsData,

    curWeekStart, 
    curWeekEnd,  
    setPurchaseList, 
    purchase, 
    history, 
    deleteUser, 
    restoreUser, 
    notify, 
    id, 
    idid, 
    handleSubmit
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    const statusIcon = e => {
        switch(e){
            case "Approved":
                return <span style = {{color: "green"}}>✓</span>;
            case "Reject":
                return <span style = {{color: "red"}}>✘</span>;
            default: 
        }
    }
    //--------------------------------------------------------------------------------------------
    const quoteUploadRef = useRef();
    const receiptUploadRef = useRef();
    //--------------------------------------------------------------------------------------------
    const [comments, setComments] = useState(purchase.approverNotes || "");
    const [showTransferSelect, setShowTransferSelect] = useState(false);
    const [contextMenu, setContextMenu] = useState({show: false});
    //const [styleIn, setStyleIn] = useState(false);
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        // window.requestAnimationFrame(() => {
        //     setStyleIn(styleIn => !styleIn);
        // });
        // return () => window.requestAnimationFrame(() => {
        //     setStyleIn(styleIn => !styleIn);
        // })
    }, [])
    //--------------------------------------------------------------------------------------------
    return(
    <div className = "border" style = {{borderRadius: "6px"}}>
        <div style = {{display: "flex"}}>
            <div className = "col-4">
                <table className = "table table-responsive-xl noTopBorder">
                <colgroup>
                    <col/>
                </colgroup>
                    <tbody>
                        <tr>
                            <th>{purchase.permit === "Yes"?`Permit / License`:""}</th>
                            {JSON.parse(purchase.approval).map((level, levelIndex) =>
                            <th key = {levelIndex}>Level {levelIndex + 1} {statusIcon(purchase.approverDecision)}</th>
                            )}
                        </tr>
                        <tr>
                            <th>Approver</th>
                            {JSON.parse(purchase.approval).map((level, levelIndex) =>
                            <td key = {levelIndex}>
                                {
                                    level.approverEmail?
                                    <span style = {{color: "blue", cursor: "pointer"}}>
                                        <UserInfo 
                                            name = {usersListMap[level.approverEmail]?.label}
                                            email = {level.approverEmail}
                                        />
                                    </span>
                                    :(level.candidateEmail || []).length === 1?
                                    <span style = {{color: "blue", cursor: "pointer"}}>
                                        <UserInfo 
                                            name = {usersListMap[level.candidateEmail?.[0]]?.label}
                                            email = {level.candidateEmail?.[0]}
                                        />
                                    </span>
                                    :
                                    <span>
                                        one of the following:
                                        {(level.candidateEmail || []).map((singleCandidateEmail, singleCandidateEmailIndex) => 
                                            <li key = {singleCandidateEmailIndex}>
                                                <UserInfo 
                                                    name = {usersListMap[singleCandidateEmail]?.label}
                                                    email = {singleCandidateEmail}
                                                />
                                            </li>)}
                                    </span>
                                }
                            </td>
                            )}
                        </tr>
                        <tr>
                            <th>Review Time</th>
                            {JSON.parse(purchase.approval).map((level, levelIndex) =>
                            <td key = {levelIndex}>
                                {!level.reviewTime?"":level.reviewTime}
                            </td>
                            )}
                        </tr>
                        <tr>
                            <th>Review Decision</th>
                            {JSON.parse(purchase.approval).map((level, levelIndex) =>
                            <td key = {levelIndex}>
                                {level.approverDecision}
                            </td>
                            )}
                        </tr>
                        <tr>
                            <th>Approver Notes</th>
                            {JSON.parse(purchase.approval).map((level, levelIndex) =>
                            <td key = {levelIndex} style = {{whiteSpace: "pre-wrap"}}>
                                {level.approverNotes}
                            </td>
                            )}
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className = "col-4">
                <table className = "table table-responsive-xl noTopBorder">
                    <tbody>
                        <tr>
                            <th>PO Date</th>
                            <td>{purchase.poDate}</td>
                        </tr>
                        <tr>
                            <th>Submitter</th>
                            <td>
                                <UserInfo 
                                    name = {purchase.submitter}
                                    email = {purchase.submitterEmail}
                                />
                                <span className = "ml-3">{!purchase.submitTime?"":purchase.submitTime}</span>
                            </td>
                        </tr>
                        {!purchase.dateUpdated?<></>:
                        <tr>
                            <th>Re-Submitter</th>
                            <td>
                                <UserInfo 
                                    name = {purchase.updater}
                                    email = {purchase.updaterEmail}
                                />
                                <span className = "ml-3">{purchase.dateUpdated}</span>
                            </td>
                        </tr>
                        }
                        <tr>
                            <th>Notified at</th>
                            <td>
                                <span className = "ml-3">{purchase.notify}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className = "col-4">
                <table className = "table table-responsive-xl noTopBorder">
                    <tbody>
                        <tr>
                            <th>Payment Method</th>
                            <td>{purchase.paymentMethod}</td>
                        </tr>
                        <tr>
                            <th>Last 4 Digit</th>
                            <td>{purchase.last4}</td>
                        </tr>
                        <tr>
                            <th>Client Invoice Number</th>
                            <td>{purchase.clientInvoiceNumber}</td>
                        </tr>
                        <tr>
                            <th>Notes</th>
                            <td>
                                <span className = "cssNotes">
                                    {purchase.notes}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        {user.purchases === "paid" && !purchase.void?<div className = "text-right mr-5">
            {!purchase.paid?
            <span className = "btn btn-primary"
            onClick = {async() => {
                const formData = new MyFormData();
                formData.append("poNumber", purchase.poNumber);
                formData.append("paid", "yes");
                //------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios("purchases/paid.php", formData);
                setShowLoader(false);
                if(!res) return;
                //------------------------------------------------------------
                setPurchaseList(purchaseList => purchaseList.map(localPurchase =>
                    localPurchase.poNumber === purchase.poNumber?
                    {...localPurchase, paid: "yes"}
                    :
                    localPurchase
                ));
                history.push(`/${title}`);
                setTimeout(() => {
                    scroll(purchase.poNumber);
                }, 200);
                
            }}
            >Mark As Paid</span>
            :
            <span
                className = "btn btn-info"
                onClick = {async() => {
                    const formData = new MyFormData();
                    formData.append("poNumber", purchase.poNumber);
                    formData.append("paid", "");
                    //------------------------------------------------------------
                    setShowLoader(true);
                    const res = await myAxios("purchases/paid.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //------------------------------------------------------------
                    setPurchaseList(purchaseList => purchaseList.map(localPurchase =>
                        localPurchase.poNumber === purchase.poNumber?
                        {...localPurchase, paid: ""}
                        :
                        localPurchase
                    ));
                    history.push(`/${title}`);
                    setTimeout(() => {
                        scroll(purchase.poNumber);
                    }, 200);
                }}
            >Unmark As Paid</span>
            }
        </div>:<></>}
        <div className = "table-responsive" style = {{minWidth: "800px",maxWidth: "90%", margin: "20px auto"}}>
            <table className = "table">
                <thead>
                    <tr>
                        <th>Vendor Name</th>
                        {purchase.category === "Vehicle Maintenance"?<>
                        <th>Vechile</th>
                        <th>Part Number</th>
                        </>:<></>}
                        <th>Description</th>
                        <th>Unit Price</th>
                        <th>Quantity</th>
                        <th>Line Total</th>
                    </tr>
                </thead>
                <tbody>
                    {JSON.parse(purchase.data).map((line, i)=> 
                    <tr key = {i}>
                        <td>
                            <Link to = {`/Vendors/${line.vendor}`}>
                                {vendorList.find(v => v.vendorHashKey === line.vendor)?.vendorName}
                            </Link>
                        </td>
                        {purchase.category === "Vehicle Maintenance"?<>
                        <td>{line.vechile}</td>
                        <td>{line.partNumber}</td>
                        </>:<></>}
                        <td>{line.description}</td>
                        <td>{line.unitPrice}</td>
                        <td>{line.quantity}</td>
                        <td>{line.lineTotal}</td>
                    </tr>
                    )
                    }
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>Subtotal:</td>
                        <td>{purchase.subtotal}</td>
                    </tr>
                    <tr>
                        <td style = {{borderTop:"none"}}></td>
                        <td style = {{borderTop:"none"}}></td>
                        <td style = {{borderTop:"none"}}></td>
                        <td>Sales Tax:</td>  
                        <td>{purchase.tax}</td>
                    </tr>
                    <tr>
                        <td style = {{borderTop:"none"}}></td>
                        <td style = {{borderTop:"none"}}></td>
                        <td style = {{borderTop:"none"}}></td>
                        <td>Discount:</td>
                        <td>{purchase.discount}</td>
                    </tr>
                    <tr>
                        <td style = {{borderTop:"none"}}></td>
                        <td style = {{borderTop:"none"}}></td>
                        <td style = {{borderTop:"none"}}></td>
                        <td>Total:</td>
                        <td>{purchase.total}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <input
            type = "file"
            accept = {mimeTypeMap.pdf}
            ref = {quoteUploadRef}
            style = {{
                display: "none"
            }}
            onChange = {async e => {
                const target = e.currentTarget;
                const files = target.files;
                if(files.length === 1){
                    const file = files[0];
                    const reader = new FileReader();
                    reader.onload = async ()=> {
                        const arr = (new Uint8Array(reader.result)).subarray(0, 5);
                        let header = "";
                        for(var i = 0; i < arr.length; i++){
                            header += arr[i].toString(16);
                        }
                        if(header !== "255044462d"){
                            window.alert("this is not a PDF file.");
                            return;
                        }
                        const formData = new MyFormData();
                        formData.append("type", "quotation");
                        formData.append("poNumber", purchase.poNumber);
                        formData.append("quoteLink", purchase.quoteLink);
                        formData.append("quotation", file);
                        //------------------------------------------------------------
                        setShowLoader(true);
                        const res = await myAxios("purchases/addFile.php", formData);
                        setShowLoader(false);
                        if(!res) return;
                        //------------------------------------------------------------
                        setPurchaseList(purchaseList => purchaseList.map(localPurchase =>
                            localPurchase.poNumber === purchase.poNumber?
                            {
                                ...localPurchase, 
                                quoteLink: res.data,
                            }
                            :
                            localPurchase
                        ));
                        history.push(`/${title}`);
                        setTimeout(() => {
                            scroll(purchase.poNumber);
                        }, 200);
                    };
                    reader.readAsArrayBuffer(file);
                }
                target.value = "";
            }}
        />
        <input
            type = "file"
            accept = {mimeTypeMap.pdf}
            ref = {receiptUploadRef}
            style = {{
                display: "none"
            }}
            onChange = {async e => {
                const target = e.currentTarget;
                const files = target.files;
                if(files.length === 1){
                    const file = files[0];
                    const reader = new FileReader();
                    reader.onload = async () => {
                        const arr = (new Uint8Array(reader.result)).subarray(0, 5);
                        let header = "";
                        for(var i = 0; i < arr.length; i++){
                            header += arr[i].toString(16);
                        }
                        if(header !== "255044462d"){
                            window.alert("this is not a PDF file.");
                            return;
                        }
                        const formData = new MyFormData();
                        formData.append("type", "receipt");
                        formData.append("poNumber", purchase.poNumber);
                        formData.append("receiptLink", purchase.receiptLink);                    
                        formData.append("receipt", file);
                        //------------------------------------------------------------
                        setShowLoader(true);
                        const res = await myAxios("purchases/addFile.php", formData);
                        setShowLoader(false);
                        if(!res) return;
                        //------------------------------------------------------------
                        setPurchaseList(purchaseList => purchaseList.map(localPurchase =>
                            localPurchase.poNumber === purchase.poNumber?
                            {
                                ...localPurchase, 
                                receiptLink: res.data,
                            }
                            :
                            localPurchase
                        ));
                        history.push(`/${title}`);
                        setTimeout(() => {
                            scroll(purchase.poNumber);
                        }, 200);
                    };
                    reader.readAsArrayBuffer(file);
                }
                target.value = "";
            }}
        />
        {!purchase.void?<>
        <div className = "m-3 text-right">
            {purchase.decision === "Submitted"?
            <span className = "btn btn-success m-3" onClick = {notify} id = {purchase.poNumber}>Notify Approver</span>:<></>}
            <span className = "btn btn-dark m-3" onClick = {async () => {
                if(!window.confirm("Are you sure to swap file between quotation and receipt?")) return;
                let fileNames = "";
                if(purchase.quoteLink && purchase.receiptLink){
                    fileNames = JSON.stringify([
                        {
                            id: purchase.quoteLink.split("/")[5], 
                            name: purchase.poNumber + " receipt.pdf"
                        },
                        {
                            id: purchase.receiptLink.split("/")[5], 
                            name: purchase.poNumber + " quotation.pdf"
                        }
                    ]);
                }else if(purchase.quoteLink){
                    fileNames = JSON.stringify([{
                        id: purchase.quoteLink.split("/")[5], 
                        name: purchase.poNumber + " receipt.pdf"
                    }]);
                }else if(purchase.receiptLink){
                    fileNames = JSON.stringify([{
                        id: purchase.receiptLink.split("/")[5], 
                        name: purchase.poNumber + " quotation.pdf"
                    }])
                }
                const formData = new MyFormData();
                formData.append("form", "changeFileName");
                formData.append("fileNames", fileNames);
                formData.append("poNumber", purchase.poNumber);
                formData.append("quoteLink", purchase.quoteLink);
                formData.append("receiptLink", purchase.receiptLink);
                //------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios("purchases/move.php",  formData)
                setShowLoader(false);
                if(!res) return;
                //------------------------------------------------------------
                setPurchaseList(purchaseList => purchaseList.map(localPurchase =>
                    localPurchase.poNumber === purchase.poNumber?
                    {
                        ...localPurchase, 
                        quoteLink: purchase.receiptLink,
                        receiptLink: purchase.quoteLink,
                    }
                    :
                    localPurchase
                ));
                history.push(`/${title}`);
                setTimeout(() => {
                    scroll(purchase.poNumber);
                }, 200);
            }}>
                Swap File
            </span>
            {purchase.poType === "pr" || true?
            <span className = "btn btn-warning m-3" onClick = {e => {
                const rect = e.target.getBoundingClientRect();
                setContextMenu(
                    {...contextMenu, 
                    show: true,
                    width: rect.width, 
                    top: rect.top + rect.height + window.scrollY,
                    left: rect.left + window.scrollX,
                    category: "quotation",
                    purchase: purchase,
                    update: () => {quoteUploadRef.current.click()}
                });
            }}>
                Quotation
            </span>
            :<></>}
            <span className = "btn btn-info m-3" onClick = {e => {
                const rect = e.target.getBoundingClientRect();
                setContextMenu(
                    {...contextMenu, 
                    show: true,
                    width: rect.width, 
                    top: rect.top + rect.height + window.scrollY,
                    left: rect.left + window.scrollX,
                    category: "receipt",
                    purchase: purchase,
                    update: () => {receiptUploadRef.current.click()}
                });
            }}>
                Receipt
            </span>

            <span className = "btn btn-primary m-3" onClick = {e => {
                const rect = e.target.getBoundingClientRect();
                setContextMenu(
                    {...contextMenu, 
                    show: true,
                    width: rect.width, 
                    top: rect.top + rect.height + window.scrollY,
                    left: rect.left + window.scrollX,
                    category: "form",
                    purchase: purchase,
                    update: () => history.push(`/${title}/${id}/Edit`)
                });}}>Form</span>
            <span className = "btn btn-secondary m-3" onClick = {async () => {
                if(!window.confirm("Regenerate the PO form PDF/Excel from saved data? The old Drive files will be deleted if present.")) return;
                const formData = new MyFormData();
                formData.append("poNumber", purchase.poNumber);
                formData.append("deleteOld", "yes");
                //------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios("purchases/regenerate.php", formData);
                setShowLoader(false);
                if(!res) return;
                //------------------------------------------------------------
                setPurchaseList(purchaseList => purchaseList.map(localPurchase =>
                    localPurchase.poNumber === purchase.poNumber?
                    {
                        ...localPurchase,
                        formId: res.data.new?.pdfId || localPurchase.formId,
                        excelId: res.data.new?.excelId || localPurchase.excelId,
                    }
                    :
                    localPurchase
                ));
                history.push(`/${title}`);
                setTimeout(() => {
                    scroll(purchase.poNumber);
                }, 200);
            }}>Regenerate Form</span>
            <span className = "btn btn-danger m-3" onClick = {deleteUser} id = {purchase.poNumber}>Void PO</span>
            {contextMenu.show?
            <MyContextMenu 
                history = {history}
                {...contextMenu}
                setContextMenu = {setContextMenu}
                setPurchaseList = {setPurchaseList}
                curWeekStart = {curWeekStart}
                curWeekEnd = {curWeekEnd}
            />:<></>}
        </div>
        <div className = "m-3 text-right">
            <a href = "https://combinepdf.com/" target = "_blank" rel = "noreferrer">
                <span className = "btn btn-success m-3">
                    Combine PDF
                </span>
            </a>
            <a href = "https://jpg2pdf.com/" target = "_blank" rel = "noreferrer">
                <span className = "btn btn-success m-3">
                    JPG to PDF
                </span>
            </a>
            <a href = "https://png2pdf.com/" target = "_blank" rel = "noreferrer">
                <span className = "btn btn-success m-3">
                    PNG to PDF
                </span>
            </a>
            <a href = "https://doctopdf.com/" target = "_blank" rel = "noreferrer">
                <span className = "btn btn-success m-3">
                    DOC to PDF
                </span>
            </a>
        </div>
        </>:<></>}
        {
        JSON.parse(purchase.approval).filter(a => (a.candidateEmail || []).includes(user.email)).length &&
        !JSON.parse(purchase.approval).filter(a => (a.candidateEmail || []).includes(user.email))[0].approverEmail
        ?(purchase.void !== "yes"?
        <div className = "mb-4">
            <div>
                <span className = "btn btn-warning m-3" onClick = {() => {
                    setShowTransferSelect(true);
                }}>Forward Approval</span>
            </div>
            {showTransferSelect?
            <TransferSelect
                usersList = {usersList}
                closeIt = {() => setShowTransferSelect(false)}
                handleSubmit = {async e => {
                    e.preventDefault();
                    const formData = new MyFormData(e.currentTarget);
                    const forward = JSON.parse(formData.get("forward"));
                    if(!forward.email){
                        window.alert("Select an approver first.");
                        return;
                    }
                    formData.append("poNumber", purchase.poNumber);
                    formData.append("forwardEmail", forward.email);
                    //------------------------------------------------------------
                    setShowLoader(true);
                    const res = await myAxios("purchases/forward.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //------------------------------------------------------------
                    setPurchaseList(purchaseList => purchaseList.map(localPurchase =>
                        localPurchase.poNumber === purchase.poNumber?
                        {
                            ...localPurchase, 
                            approval: res.data,
                        }
                        :
                        localPurchase
                    ));
                    setShowTransferSelect(false);
                    history.push(`/${title}`);
                    setTimeout(() => {
                        scroll(purchase.poNumber);
                    }, 200);
                }}
            />:<></>}

            <div style = {{marginLeft: "5%", marginBottom: "10px"}}>Approval Notes</div>
            <textarea className = "form-control" style = {{width:"90%", margin: "auto"}} value = {comments} onChange = {e => {setComments(e.currentTarget.value)}} name = "comments"/>
            <div>
                {[
                    {title:"Approve", decision:"Approved", word: "approve", color: "btn-success"}, 
                    {title:"Reject", decision:"Rejected", word: "reject", color: "btn-danger"}
                ].map((d, di) => 
                <span key = {di} className = {`btn ${d.color} mx-3 mt-3`} onClick = {async() => {
                    if(!window.confirm(`Are you sure to ${d.word} this PO?`)) return;
                    const formData = new MyFormData();
                    formData.append("poNumber", purchase.poNumber);
                    formData.append("approverDecision", d.decision);
                    formData.append("approverNotes", comments);
                    //------------------------------------------------------------
                    setShowLoader(true);
                    const res = await myAxios("purchases/approval.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //------------------------------------------------------------
                    setPurchaseList(purchaseList => purchaseList.map(localPurchase =>
                        localPurchase.poNumber === purchase.poNumber?
                        {
                            ...localPurchase, 
                            approval: res.data.approval,
                            formId: res.data.formId || localPurchase.formId,
                        }
                        :
                        localPurchase
                    ));
                    history.push(`/${title}`);
                    setTimeout(() => {
                        scroll(purchase.poNumber);
                    }, 200);
                }}>{d.title}</span>)}
            </div>
        </div>
        :<>
        </>
        ):<></>
        }
        {purchase.void?<>
        <div className = "m-4 font-weight-bold h3">Void</div>
        <div className = "m-4"><span className = "h4 mr-3">Void Reason:</span>{purchase.voidReason}</div>
        <div className = "m-4"><span className = "btn btn-success" onClick = {restoreUser} id = {purchase.poNumber}>Valid</span></div>
        </>:<>
        </>}
        {(idid) === "Edit"?
        <PurchaseForm 
            {...purchase} 
            vendorList = {vendorList} 
            usersList = {usersList} 
            usersListMap = {usersListMap}
            paymentMethodsData = {paymentMethodsData}
            projectsList = {projectsList} 
            projectsListMap = {projectsListMap}
            handleSubmit = {handleSubmit} 
            closeIt = {() => history.push(`/${title}/${id}`)} keyword = "Update"
        />:<></>}
    </div>
    )
}